export const locale = {
    lang: 'en',
    data: {
      'ALERTS':{
        'OK':'OK'
      },
      'SHEDULE': {
        'ERROR_RE':'The reminder date can not be earlier than launch date',
        'TITLE1': 'Register release date',
        'TITLE2': 'Register reminder',
        'TITLE3': 'Register close',
        'ERR01':'The reminders can not be minor than the launch day',
        'ERR02':'The reminders can not be  greater than the close day',
        'ERR03':'The reminders must in the course of survey',
        'ERR04':'you only can have 3 reminders',
        'ERR05':'The date can not be lower than now',
        'ERR06':'You already has send a email today',
        'SUC01':'Reminder save',
        'SELECT_DATE': 'Select a date',
        'SAVE': 'Save',
        'RECORDATORIOS': 'Reminders',
        'RECORDATORIO': 'Reminder', // Campo nuevo
        'ERRORDATE':'The date can not be prior that now', // Campo nuevo
        'SAMEDATE':'Choosing the current date as the survey launch date is not allowed',

        'LESSDAYS_T':'Are you sure to continue?',
        'LESSDAYS_I':'You need to schedule the survey launch date at least 15 days before the launch in order to the collaborators to receive the full communication plan.',
        'CONFLDATE_T':'Warning!',
        'CONFLDATE_I':'If you proceed you could not revert the survey launch date programming.',
        'WARNING_FECHA_UPDATE':" You cannot select today's date or before this ",
        'FECHA_UPDATE_WARNING':'Be sure to change the closing date',
        'FECHA_UPDATE':'The closing date was updated correctly',

        'FECHA': 'Date',
        'AGREGAR': 'Add',
        'EDITAR': 'Edit',
        'COMPLETAR_PASO': 'Complete step',
        'PASO_COMPLETADO': 'Step completed',
        'LOCK':'Reopen step',
        'UNLOCK':'Step in process',
        'SUBIRLOGO': 'To create your survey you need to upload your company logo',
        'ACEPTARREQUERIMIENTOS': 'To create your survey it is necessary to accept the technical requirements',
        'LOGOSSURVEY': 'To create your survey it is necessary to first establish the necessary logo (s)',

        'SELECCIONE_FECHA': 'Please, select a date',
        'DATE_REGISTERED': 'Launch Date Registered Successfully',
        'CLOSE_REGISTERED': 'Close Date Registered Successfully',
        'CLOSE_MSJ1': 'The closing date must be greater than the release date',
        'CLOSE_MSJ2': 'Before registering close, you must register the Release date',
        'REMIDEROK': 'Reminder registered correctly',
        'REMIDERUPDAOK': 'Reminder successfully updated',
        'AVIUPDAOK': 'Properly updated notice',
        'REMIDER_MSJ1': 'The reminder must be greater than the release date',
        'REMIDER_MSJ2': 'Before registering a reminder you must register the Release date',
        'ESPERA_ENCUESTA': 'Wait, this may take a few minutes.',

        'ENCUESTA': 'Survey',
        'CREANDO_ENCUESTA': 'Creating survey...',
        'AGREGANDO_USUARIOS': 'Adding users...',
        'AGREGANDO_SECCION1': 'Adding NPS to the survey...',
        'AGREGANDO_SECCION2': 'Adding STATEMENTS to the survey...',
        'AGREGANDO_SECCION3': 'Adding CONTROL to the survey...',
        'AGREGANDO_SECCION4': 'Adding DEMOGRAPHICS to the survey...',
        'AGREGANDO_SECCION5': 'Adding ADDITIONAL to the survey...',
        'AGREGANDO_SECCION6': 'Adding FORALL to the survey...',
        'AGREGANDO_SECCION7': 'Adding Open questions to the survey...',
        'REINTENTAR': 'Retry',
        'ERROR_ENCUESTA': 'Error creating survey',
        'ERROR_USUARIOS': 'Error adding users...',
        'ERROR_SECCION1': 'Error adding NPS to survey...',
        'ERROR_SECCION2': 'Error adding STATEMENTS to the survey...',
        'ERROR_SECCION3': 'Error adding CONTROL to survey...',
        'ERROR_SECCION4': 'Error adding DEMOGRAPHICS to the survey...',
        'ERROR_SECCION5': 'Error adding ADDITIONAL to the survey...',
        'ERROR_SECCION6': 'Error adding FORALL to survey...',
        'ERROR_SECCION7': 'Error adding Open questions to survey...',

        'SUCCESS_ENCUESTA': 'Survey created successfully!',
        'SUCCESS_USUARIOS': 'Users added successfully!',
        'SUCCESS_SECCION1': 'NPS successfully added to the survey!',
        'SUCCESS_SECCION2': 'STATEMENTS successfully added to the survey!',
        'SUCCESS_SECCION3': 'CONTROL QUESTION successfully added to the survey!',
        'SUCCESS_SECCION4': 'DEMOGRAPHICS successfully added to the survey!',
        'SUCCESS_SECCION5': 'ADDITIONALS successfully added to the survey!',
        'SUCCESS_SECCION6': 'FOR ALL successfully added to the survey!',
        'SUCCESS_SECCION7': 'Open questions successfully added to the survey!',
        'BTN_CREARENCUESTA': 'Create survey',

        'CONTINUE_FINISH': 'Survey created successfully, you can finish the step.',
        'LAUNCH_SURVEY': 'Please, create the surver to complete the step',
        'PULSE':{
            //Shedule survey
          'MES1': ' Pulse Check month 1',
          'MES2': ' Pulse Check month 2',
          'MES3': ' Pulse Check month 3',
          'MES4': ' Pulse Check month 4',
          'MES5': ' Pulse Check month 5',
          'MES6': ' Pulse Check month 6',
          'MES7': ' Pulse Check month 7',
          'MES8': ' Pulse Check month 8',
          'MES9': ' Pulse Check month 9',
          'MES10': ' Pulse Check month 10',
          'MES11': ' Pulse Check month 11',
          'MES12': ' Pulse Check month 12',
          'INDICA': 'Select the pulse check date',
          'INDICA_GENERA':'Generate Survey',
          'SUBINDICA_GENERA':'Click to generate survey',


             },



      },
      'SHEDULE2_0': {
        'CARDS': {
          'ERROR':'The reminder date can not be earlier than launch date',
          'PASO1': {
            'TITULO': 'Prerequisites',
            'INFO_PRE': 'You need to cover these prerequisites first before creating the survey',
            'INFO_POST': 'You have already met the prerequisites to create the survey',
            'REQTEC': 'Technical requirements',
            'REQTEC_TOOLTIP': 'Go to technical requirements',
            'LOGO': 'Company logo',
            'LOGO_TOOLTIP': 'Click to load the logo',

          },
          'PASO2': {
            'TITULO': 'Release date',
            'TITULO_CIERRE': 'Closing date',
            'INFO_PRE': 'Select and record the launch date for the survey',
            'INFO_POST': 'Selected date',
            'PICKDATE': 'Open calendar',
            'INFO_POST_CIERRE': 'Current Closing Date',
            'CHANGE': 'Change date',
            'LIS-PRORRO':' extensions',
          },
          'PASO2_B': {
            'TITULO': 'Date selection',
            'INFO_PRE': 'Select and register the different dates available to configure the survey',
            'PICKDATE': 'Choose dates',
            'INFO_PROR': 'Extensions have been assigned to this product',
            'PRORROGAS': 'See extensions',
            'TIUTLOLISTA': 'Extensions created',
            'NOPROR': 'You have no assigned extensions'
          },
          'PASO3': {
            'TITULO': 'Reminders',
            'INFO_PRE': 'Add reminder submission dates to answer the survey',
            'INFO_POST': 'You have two options:',
            'NUEVO': 'Register new reminder',
            'LISTA': 'Recorded reminders',
            'LISTA_AVI': 'Pre-survey communication',
            'TITU_AVIS':'Ads',
            'TIUTLOLISTA': 'Reminders created',
            'NORECOS': 'You have not saved any reminders',
            'NOAVI': 'You have not saved any warnings',
            'INFOHORA': 'NOTE: Each reminder is displayed in the institute\'s local time:',
            'INFOHORAAVISO': 'NOTE: Each announcement is displayed in the institute\'s local time:',
            'TITULOLISTA': 'Notices created',
          },
          'PASO4': {
            'TITULO': 'Communication messages',
            'INFO_PRE': 'Review the communication messages to be sent during the survey life cycle',
            'VERMENSAJES': 'See communication messages'
          },
          'PASO5': {
            'TITULO': 'Survey check',
            'TITULO_ALT': 'Master Table Check',
            'INFO_PRE': 'Review the sections of the survey, as well as the number of questions added in each section',
            'VERMENSAJES': 'See section data',
            'FILTRAR': 'Filter sections by name',
            'TABLE':{
              'SECTION': 'Section',
              'VALUE': 'Value',
              'INACTIVE':'Inactive',
              'ACTIVE':'Active',
              'CLOSE':'Closed'
            }
          },
          'PASO6': {
            'TITULO': 'Survey Generation History',
            'INFO_PRE': 'Last survey generation date:',
            'INFO_PRE_2': 'Generation history:',
            'ERRORHISTORIAL':'You do not have your history cause the survey has not been created'
          },
          'PASO7': {
            'TITULO': 'Survey characteristics',
            'INFO_PRE': 'Before configuring the survey features, you need to first complete the prerequisites',
            'INFO_POST_1': 'Before creating the survey it is necessary to configure the characteristics of the survey',
            'INFO_POST_2': 'You have already set the necessary settings to create the survey',
            'EMPRESA': 'Company logo',
            'CERTIFICADO': 'Certificate logo',
            'CARACTERISTICAS': 'Survey characteristics',
            'PREVIEW': 'Preview',
            'CAMBIAR': 'Change image',
            'LOGO_EMP_INFO': 'The image is displayed in its saved resolution, 200x200 pixels'
          },
          'MODALGEN': {
            'REGRESAR': 'Go back',
            'HISTORIAL': {
              'BOTON': 'Survey generation history',
              'TITULO': 'Survey generation history',
              'CARGANDO': 'Loading generation history',
              'ULTIMA': 'Last generation date',
              'ANTERIORES': 'Previous generation dates',
              'NOHISTO': 'There is no history of the generation of the survey'
            },
            'CERTIFICADO': {
              'TITULO': 'Certificate preview'
            },
            'URL_QR': {
              'BOTON': 'Get link in QR code',
              'TITULO': 'Survey link in QR code',
              'SUBTITULO': 'By scanning this QR code you can directly access the survey without having to enter the link manually',
              'DESCARGA': 'To download the QR code, right click on the image and then on the <b> <em> Save image as ... </em> </b> option',
              'REGENERARQR': 'The URL was modified correctly, if you have a QR code from the previous URL, you need to get a new QR code with the updated link'
            }
          },
          'STATUS': {
            'PENDING': 'Not yet complete',
            'OK': 'Ready',
            'OPT': 'This step is optional'
          },
          'FECHAS': {
            'TITULO': 'Date selection',
            'FECHA': 'Selected date:',
            'NOTYET': 'Not yet chosen',
            'INFO': {
              '1': 'Select each of the available dates to configure the survey.',
              '2': 'NOTE: The time selected on each date is set to the institute\'s local time:'
            },
            'TABLA': {
              'TIPO': 'Type of date',
              'FECHA': 'Selected date',
              'ACCIONES': 'Actions'
            },
            'TIPOS': {
              'lanzamiento': 'Launch date',
              'aviso1': 'Pre-launch (First notification before survey launch)',
              'aviso2': 'Pre-launch (Second notification before survey lauch)',
              'cierre': 'Deadline',
              'recor30': 'Pre-launch (Notice 30 days before the survey)',
              'recor29': 'Pre-launch (Notice 29 days before the survey)',
              'recor15': 'Pre-launch (Notice 15 days before the survey)',
              'recor7': 'Pre-launch (Notice 7 days before the survey)',
              'result': 'Results:',
            },
            'BOTONES': {
              'ELEGIR': 'Choose date',
              'CAMBIAR': 'Change date',
              'CANCELAR': 'Cancel',
              'ACEPTAR': 'Accept',
              'ENVIOCIERRE': 'Send notification'
            }
          }
        },
        'CREAR': 'Create survey',
        'RECREAR': 'Re-create survey',
        'ENCUESTACREADA': 'Survey created',
        'ENCUESTAERROR': 'The survey was not created correctly',
        'VERSECCIONES': 'See added sections',
        'BACK': 'Back',
        'CERRAR': 'Close',
        'CREANDO': 'The survey is being created, wait until each of its components is added correctly',
        'RETRY': 'Retry the process',
        'SECCIONES': {
          'DETALLES': 'Saving last details',
          'COMPLETA': 'The survey was created successfully!',
          'ENCUESTA': {
            'TITULO': 'Survey',
            'PROCESO': 'Creating survey',
            'ERROR': 'An error occurred while creating the survey, please try the process again'
          },
          'USUARIOS': {
            'TITULO': 'Users',
            'PROCESO': 'Adding users to the survey',
            'ERROR': 'An error occurred while adding the users, try the process again',
          },
          'NPS': {
            'TITULO': 'NPS',
            'PROCESO': 'Adding NPS to the survey',
            'ERROR': 'An error occurred while adding NPS, please retry the process',
          },
          'REACTIVOS': {
            'TITULO': 'Statements',
            'PROCESO': 'Adding statements to the survey',
            'ERROR': 'An error occurred while adding the statements, please try the process again',
          },
          'CONTROL': {
            'TITULO': 'Control question',
            'PROCESO': 'Adding control question to the survey',
            'ERROR': 'An error occurred while adding the control question, try the process again',
          },
          'DEMOGRAFICOS': {
            'TITULO': 'Demographics',
            'PROCESO': 'Adding demographics to the survey',
            'ERROR': 'An error occurred while adding the demographics, please retry the process',
          },
          'ABIERTAS': {
            'TITULO': 'Open questions',
            'PROCESO': 'Adding open questions to the survey',
            'ERROR': 'An error occurred while adding open questions, please try the process again',
          },
          'FORALL': {
            'TITULO': 'Forall',
            'PROCESO': 'Adding ForAll practices to the survey',
            'ERROR': 'An error occurred while adding the ForAll practices, retry the process',
          },
          'ADICIONALES': {
            'TITULO': 'Additional',
            'PROCESO': 'Adding additional questions to the survey',
            'ERROR': 'An error occurred while adding additional questions, please try the process again',
          },
          'ADICIONALES-FOCUS': {
            'TITULO': 'Personalized',
            'PROCESO': 'Adding custom questions to the survey',
            'ERROR': 'An error occurred while adding the custom questions, please try the process again',
          },
        },
        'MODALES': {
          'ENCUESTA': {
            'CREAR_1': 'Do you want to create the survey with the current configuration?',
            'CREAR_2': 'Once the survey is created, you will not be able to modify the communication messages',
            'CREAR_3': 'Do you want to start the survey creation',
            'SINFECHA': 'To create the survey it is necessary to first choose the launch date of the same',
            'CREADA_1': 'The survey was created successfully!',
            'CREADA_2': 'You can now complete this section and continue with the next',
            'RECOEXIS': 'There is already a registered reminder for the selected day',
            'RECOBEFORE': 'You cannot record a reminder without first choosing the survey launch date',
            'RECOMAX': 'You have already programmed all allowed reminders, you can no longer register new ones',
            'LASTRECO_1': 'Warning:',
            'LASTRECO_2': 'You have scheduled all allowed reminders, you will no longer be able to register new ones',
            'LISTARECOBEF': 'You cannot view the reminder list without first choosing the survey launch date',
            'FINAL': 'You can now complete this section and continue with the next',
            'SAVELAUNCHDATE': 'Saving survey launch date, please wait a while',
            'SAVEAVISODATE': 'Saving the notification date, please wait a while',
            'AVISOOK': 'Notification date saved successfully',
            'CHANGELAUNCH': 'Warning: If you change the launch date of the survey, the rest of the dates will be erased and you will have to select them again, do you want to choose another launch date?',
            'CHANGECLOSENOT': 'The notification sending status was changed successfully',
            'GUARDANDO_LOGO': 'Saving image, wait a moment',
            'CARGA_CERT': 'To obtain the highest quality in the final document, be sure to upload an image with a minimum resolution of 400 x 240 pixels.',
            'BORRA_RECO_1': 'Are you sure to delete the reminder with the following date?',
            'BORRA_RECO_2': 'The reminder was successfully deleted',
            'BORRA_AVI_1': 'Are you sure to delete the reminder with the following date?',
            'BORRA_AVI_2': 'The reminder was successfully reminded',
            'UPDA_AVISO':'Updating reminder date',
            'UPDA_RECOR':'Updating reminder date',
            'DELE_AVISO':'Deleting reminder date',
            'DELE_RECOR':'Deleting reminder date',
            'GUARD_RECOR':'Saving reminder date',
            'TITL_MOD_QUES_ALEAT':'To create the survey it is necessary to enable the random question validation.',
            'TEXT_MOD_QUES_ALEAT_1':'Then follow these steps:',
            'TEXT_MOD_QUES_ALEAT_2':'1.- Enter in edit the survey characteristics.',
            'TEXT_MOD_QUES_ALEAT_3':'2.- Click on additional configuration and enable the random question validation',
          }
        },
        'CORREOS': {
          'VER': 'See message',
          'TIPO1': {
              'TITULO': 'Pre-launch message',
              'INFO': 'These are the messages sent days before the launch of the survey',
              'TIPO_1': 'First notification message',
              'TIPO_2': 'Second notification message',
          },
          'TIPO2': {
              'TITULO': 'Invitation message',
              'INFO': 'This is the message sent to collaborators on the day of the survey launch'
          },
          'TIPO3': {
              'TITULO': 'Reminder message',
              'INFO': 'This is the reminder message sent on the days scheduled for this purpose'
          },
          'TIPO4': {
              'TITULO': 'First notification message',
              'INFO': ''
          },
          'TIPO5': {
              'TITULO': 'Second notification message',
              'INFO': ''
          },
          'TIPO6': {
              'TITULO': 'Survey close message',
              'INFO': 'This is the message sent to collaborators on the closing date of the survey.\nNOTE: it will only be sent if it has been activated'
          },
          'TIPO7': {
            'TITULO': 'Message to collaborators who have not started their survey',
            'INFO': 'This is the reminder message sent to contributors who have not yet started their survey'
          },
          'TIPO8': {
            'TITULO': 'Message to collaborators who have not finished yet',
            'INFO': 'This is the reminder message sent to contributors who have already started their survey but have not finished yet'
          },
        },
        'EDITOR': {
          'BOTONES': {
            'INFO': 'Important information',
            'SAVE': 'Save changes',
            'EDIT': 'Edit message',
          },
          'PENDING': 'In process of validation',
          'MODALINFO': {
            'TITULO': 'Important information about the content of the email',
            'PARTE_1': 'In order for the email to be considered correct to be sent, the following labels can be included in the body of the message (Attention, the mandatory labels must be included at least once):',
            'PARTE_2': 'The reason for this is due to the fact that when the delivery date of each email arrives, the platform automatically performs the following replacements in the message:',
            'tag_company': 'The company name',
            'tag_link': 'The access link to the survey',
            'tag_date': 'The launch date of the survey',
            'tag_user': 'Survey access password',
            'tag_dtb': 'Days until the survey launch (from the date the message is sent)',
            'tag_dtc': 'Days until the end of the survey (from the date the message is sent)',
            'tag_end': 'The closing date of the survey',
            'tag_userAction': 'User to login ',
            'tag_pass': 'Users password',
            'tag_linkAction': 'The access link to cultrural Go',
            'PARTE_3': 'Labels can be placed anywhere in the body of the email. Once the tags are present in the content, it can be saved.',
            'PARTE_4': 'Note: it is possible that the message needs to be validated by a project manager, if it is the case, you will be able to see the validation status of the new email on this screen. During the validation process you will not be able to make a new edition of the email. Otherwise, the email will be considered valid immediately and you can edit it again if you wish.',
            'OPC': '(Optional)',
            'MDT': '(Mandatory, except in the close message)'
          },
          'MODALES': {
            'SINCAMBIOS': 'You have not yet made changes to the content of the email',
            'SINTAG': 'Unable to save mail, the next tag was not found:',
            'GUARDAR_1': 'Do you want to save the changes made to the message?',
            'GUARDAR_2': 'We remind you that it will be sent for validation and you will not be able to re edit it until the validation process ends.',
            'SAVEOK_1': 'The content of the email was saved correctly',
            'SAVEOK_2': 'Wait for a project manager to validate the modifications',
            'ENABLED': 'A project manager has reactivated email editing, you may continue doing modifications',
            'CAMBIOIDIOMA_1': 'Warning: if you want to choose another language, the changes made so far in the current language must be saved first',
            'CAMBIOIDIOMA_2': 'Do you want to save the changes and choose another language?',
          }
        },
        'ZONAS': {
          '1': 'Mexico City',
          '2': 'San Salvador',
          '3': 'Hong Kong',
          '4': 'Singapore',
          '5': 'Istanbul',
          '6': 'Manila',
          '11': 'Brasilia',
          '15': 'Madrid',
          '18': 'Mexico City',
          '22': 'Hong Kong',
        },
        'SECCIONES_ESPECIALES': {
          'TITULO': 'This survey has special sections',
          'SUBTITULO': 'Below are the demo users in a grouped way, each group is intended to test the survey with each special section separately, or the survey without special sections',
          'ELEGIR': 'Select a group from the menu on the left',
          'LISTA': {
            'TITULO': 'special sections',
            'SIN_SECCION': 'Survey without special sections'
          }
        },
        'CORREOS_NORM':{
          'TIPO1':{
            'TITULO': 'Pre-launch message',
            'INFO': 'These are the messages sent days before the launch of the survey',
          },
          'TIPO2':{
            'TITULO': 'Warning message: 30 days prior to invitation launch' ,
            'INFO': 'These are the messages sent days before the launching of the survey'
          },
          'TIPO3':{
            'TITULO': 'Warning message: 29 days prior to invitation launch',
            'INFO': 'These are the messages sent days before the launching of the survey'
          },
          'TIPO4':{
            'TITULO': 'Warning message: 15 days prior to invitation launch',
            'INFO': 'These are the messages sent days before the launching of the survey'
          },
          'TIPO5':{
            'TITULO': 'Warning message: 7 days prior to invitation launch',
            'INFO': 'These are the messages sent days before the launching of the survey'
          },
          'TIPO6': {
              'TITULO': 'Survey close message',
              'INFO': 'This is the message sent to collaborators on the closing date of the survey.\nNOTE: it will only be sent if it has been activated'
          },
          'TIPO7':{
            'TITULO': 'Reminder message',
            'INFO': 'This is the reminder message sent on the days scheduled for this purpose'
          },
        }
      }
    }
};
